import React, {Component} from 'react';
import styles from './FJHeader.module.less';
import FJButtonSemicircle from "../../../common/component/button-semicircle/FJButtonSemicircle";
import FJLocalStore from "../../../store/FJLocalStore";
import FJInputFile from "fj-components/FJInputFile";
import FJSaveContainer from "../container/FJSaveContainer";
import FJProjectNameContainer from "../container/FJProjectNameContainer";
import FJExportButtonContainer from "../container/FJExportButtonContainer";
import FJUndoContainer from "../container/FJUndoContainer";
import suggestion from '../../../icon/Suggestion.svg'
import FJUtil from "../../../util/FJUtil";

class FJHeader extends Component {

  constructor(props) {
    super(props);
    this._loadInputFile = React.createRef();
  }

  _onLoadHandle = () => {
    this._loadInputFile.current.click();
    this._loadInputFile.current.val('');
  };

  _onLoadDataChange = (e) => {
    this.props.loadForLocal(e.target.files[0]);
  };

  /**
   * @description 点击跳转 contact us
   * @private
   */
  _onAdviceClick = () => {
		window.open('/contact.html?source=time-line-editor');
    FJUtil.ealog('your advice click');
  };

  render() {
    let {
      saveForLocal,
      onSignUp,
      isLogin,
    } = this.props;

    return (
      <div className={styles.container}>
        <div className={styles.left_header}>
          <FJProjectNameContainer/>
          <FJUndoContainer />
        </div>

        <div className={styles.right_header}>
          <div style={{display: 'none'}}>
            <FJButtonSemicircle text={FJLocalStore._('load')}
                                className={styles.button}
                                onClick={this._onLoadHandle}
            />
            <FJButtonSemicircle text={FJLocalStore._('save')}
                                className={styles.button}
                                onClick={saveForLocal}
            />
          </div>

          <FJButtonSemicircle className={styles.advice} icon={suggestion} text={FJLocalStore._('your-advice')} onClick={this._onAdviceClick} />

          <FJSaveContainer
            className={styles.button + ' ' + styles.save}
            textClass={styles.button_text}
            disabledClass={styles.disabled}
          />
          <FJExportButtonContainer className={styles.export_button}
																	 disabledClass={styles.export_disabled}
																	 textClass={styles.button_text}
																	 iconClass={styles.export_icon}
					/>
          {
            isLogin ?
              <div className={styles.line}/> :
              <FJButtonSemicircle text={FJLocalStore._('sign-up')}
                                  className={styles.button + ' ' + styles.sign_up}
                                  textClass={styles.button_text}
                                  onClick={onSignUp}
              />
          }

        </div>
        <FJInputFile ref={this._loadInputFile} multiple accept='.zip'
                     onChange={this._onLoadDataChange}/>
      </div>
    );
  }
}

export default FJHeader;
